import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { getParam } from '../../routing/routing.utils';
import { ROUTES } from '../../routing/routes';
import { RootState } from '../../store/rootModel';
import { MarketDataTabType } from './enums';
import { useMarketDataCmsData } from './api/hooks';
import { Spinner } from '../../lib/Spinner/Spinner';
import { Translate, MarketDataCmsData } from '../../containers/CmsData/store/cmsData.model';
import DOMPurify from 'dompurify';
import MarketDataPage from './MarketDataPage';
interface Props {
  tickerValue: string;
}
const getButtonGroupOptions = (_t: Translate<MarketDataCmsData>) => {
  return [
    {
      value: _t('c10DetailedQuoteButtonLabel'),
      key: MarketDataTabType.DetailedQuote,
      id: 'detailed-quote-btn',
    },
    {
      value: _t('c11HistoricalQuotesButtonLabel'),
      key: MarketDataTabType.HistoricalQuotes,
      id: 'historical-quotes-btn',
    },
    {
      value: _t('c12CompanyFinancialsButtonLabel'),
      key: MarketDataTabType.CompanyFinancials,
      id: 'company-financials-btn',
    },
    {
      value: _t('c13SECFillingButtonLabel'),
      key: MarketDataTabType.SecFilling,
      id: 'sec-filling-btn',
    },
  ];
};

const getIframeUrl = (
  tabType: MarketDataTabType,
  tickerValue: string,
  _t: Translate<MarketDataCmsData>,
) => {
  let urlToReplace = '';
  switch (tabType) {
    case MarketDataTabType.DetailedQuote:
      urlToReplace = _t('c10DetailedQuoteURL');
      break;
    case MarketDataTabType.HistoricalQuotes:
      urlToReplace = _t('c11HistoricalQuotesURL');
      break;
    case MarketDataTabType.CompanyFinancials:
      urlToReplace = _t('c12CompanyFinancialsURL');
      break;
    case MarketDataTabType.SecFilling:
      urlToReplace = _t('c13SECFillingURL');
      break;
    default:
      break;
  }
  return urlToReplace.replace('%SHARE_KEY%', tickerValue);
};

const getDisclaimerContent = (_t: Translate<MarketDataCmsData>) =>
  DOMPurify.sanitize(
    `${_t('sR001DisclaimerDelayedQoute')} ${_t('sR002DisclaimerMarketDataProvider')}`,
  );

const Component: React.FC<Props> = ({ tickerValue }) => {
  const { cmsDataLoading, _t } = useMarketDataCmsData();
  const getMarketIframeUrl = useCallback((actualTab) => getIframeUrl(actualTab, tickerValue, _t), [
    tickerValue,
    _t,
  ]);
  if (cmsDataLoading) {
    return <Spinner size={'md'} />;
  }
  return (
    <MarketDataPage
      buttonGroupOptions={getButtonGroupOptions(_t)}
      getMarketIframeUrl={getMarketIframeUrl}
      disclaimerContent={getDisclaimerContent(_t)}
    />
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    tickerValue: getParam(ROUTES.marketData, state.router, 'tickerValue'),
  };
};
export const MarketDataPageContainer = connect(mapStateToProps)(React.memo(Component));
